import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from 'clsx'
import ReservationSegmentSelect from "../../Selects/ReservationSegmentSelect"
import FoliosSelect from "../../Selects/FoliosSelect"
import DataTable from "../../DataTable/DataTable"

class MoveFolioItemsGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'move-folio-items-general',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="move-folio-items-general">
        <div className="row">
          {this.renderErrors()}
          <div className="col-md-3 form-group ">
            <label>{I18n.t('reservation')}</label>
            <ReservationSegmentSelect reservation_segment={this.props.reservation_segment} onChange={this.props.onChangeReservationSegment} />
          </div>
          <div className="col-md-3 form-group">
            <label>{I18n.t('folio')}*</label>
            <div >
              <FoliosSelect className={this.renderFieldClasses('folio')} folio={this.props.folio} reservation_segment_id={this.props.reservation_segment.id} onChange={this.props.onChangeFolio} />
            </div>
            {this.renderFieldErrors('folio')}

          </div>




          {/* <div className="col-md-8">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body">
                  <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('move_to')}</h5>
                  <div className="row">
                    <div className="col-md-6 form-group ">
                      <label>{I18n.t('reservation')}</label>
                      <ReservationSegmentSelect reservation_segment={this.props.reservation_segment} onChange={this.props.onChangeReservationSegment} />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>{I18n.t('folio')}*</label>
                      <div >
                        <FoliosSelect className={this.renderFieldClasses('folio')} folio={this.props.folio} reservation_segment_id={this.props.reservation_segment.id} onChange={this.props.onChangeFolio} />
                      </div>
                      {this.renderFieldErrors('folio')}

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div> */}
        </div>

        {/* <div className="row"> */}
          <div className="panel panel-default">
            <div className="panel-body container">
              <div className="table-wrap-panel">
                <DataTable
                 endpoint = {this.props.move_folio_items_data_table_path}
                 ids ={this.props.folio_items.map((folio_item) => {return folio_item.id})}
                 no_data_text = {I18n.t('none')}
                 currency_unit = {I18n.t('number.currency.format.unit')}
                 delimiter = {I18n.t('number.currency.format.delimiter')}
                 separator = {I18n.t('number.currency.format.separator')}
                 date_format = {this.props.date_format}
                 time_format = {this.props.time_format}
                 read_only = {this.props.read_only} />
              </div>
            </div>
          </div>
        {/* </div> */}


      </div>

    )
  }

  renderFieldClasses(field) {
    var classname= "form-control"
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors =
        <li key={idx}><b>&#x2022;</b> {this.props.errors[field]}</li>

      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderErrors() {
    var errors = this.props.errors
    if (errors ) {

      errors =  <li >{errors.folio}</li>

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }
}

export default MoveFolioItemsGeneral
